<template>
  <v-col class="comments">
    <div class="black-label">Comentários</div>
    <div v-if="commentsList.length > 0">
      <v-card
        v-for="(comment, index) in commentsList"
        :key="'comment-' + index"
      >
        <v-list-item>
          <v-list-item-avatar class="avatar" size="32">
            <v-img :src="avatar(comment.user.photo)"></v-img>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="title">{{
              comment.user.name
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <div class="text">{{ comment.message }}</div>
            <div class="time">
              {{ $moment(comment.date, "x").format("HH:mm") }}
            </div>
          </v-list-item-content>
        </v-list-item>
        <div class="remove-comment">
          <v-dialog v-model="removeDialog" max-width="349">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                class="close-btn"
                color="#9AABB8"
                height="12"
                width="12"
                v-if="isModerator()"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon size="8">mdi-close</v-icon>
              </v-btn>
            </template>
            <v-card>
              <v-card-title align="center" style="color: #F83030;"
                >Apagar Comentário</v-card-title
              >
              <v-card-text
                >Apagar este comentário é irreversível e não poderá voltar a criá-lo de novo.</v-card-text
              >
              <v-list-item style="padding-bottom: 12px;">
                <v-list-item-content style="padding-right: 8px;">
                  <v-btn
                    block
                    depressed
                    color="secondary"
                    height="48"
                    @click="removeDialog = false"
                    >Cancelar</v-btn
                  >
                </v-list-item-content>
                <v-list-item-content style="padding-left: 8px;">
                  <v-btn
                    block
                    depressed
                    dark
                    color="#F83030"
                    height="48"
                    @click="removeComment(comment.id)"
                    >Apagar</v-btn
                  >
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-dialog>
        </div>
      </v-card>
    </div>
    <v-card v-else class="empty-state">
      Não existem comentários
    </v-card>
    <!-- PAGINATION -->
    <v-row class="pagination">
      <v-col>
        <v-pagination
          v-model="page"
          :length="totalPages"
          :total-visible="3"
          color="#D8E0E6"
          style="float: left;"
          @input="gotToPage"
        ></v-pagination>
      </v-col>
    </v-row>
    <!-- ADD COMMENT -->
    <v-row>
      <v-col>
        <v-text-field
          dense
          solo
          flat
          filled
          hide-details
          height="48"
          placeholder="Escreve um comentário"
          name="comment"
          class="form-input"
          v-model="message"
        >
          <v-btn
            slot="append"
            block
            large
            depressed
            color="primary"
            height="32"
            @click="addComment()"
            >Enviar</v-btn
          >
        </v-text-field>
      </v-col>
    </v-row>
  </v-col>
</template>

<style scoped>
.empty-state {
  width: 100%;
  height: 135px;
  text-align: center;
  vertical-align: middle;
  line-height: 135px !important;
  font-family: Gilroy-SemiBold;
  font-size: 12px;
  color: #9aabb8;
  padding: 0 !important;
}
.black-label {
  font-family: Gilroy-Bold;
  font-size: 16px;
  line-height: 24px;
  color: #304351;
}
.comments {
  background-color: #ebeff3;
  padding: 48px 100px;
  flex: 0 0 40%;
  max-width: 40%;
}
.comments .v-card {
  padding: 16px 8px 4px 8px;
  margin-top: 16px;
  box-shadow: 0px 0px 8px rgba(48, 67, 81, 0.08);
}
.comments .avatar {
  border: 2px solid #26ab5e;
}
.comments .title {
  font-family: Gilroy-SemiBold !important;
  font-size: 14px !important;
  line-height: 24px;
  color: #304351 !important;
}
.comments .text {
  font-family: Gilroy-SemiBold;
  font-size: 12px;
  line-height: 16px;
  color: #6d818f !important;
}
.comments .time {
  font-family: Gilroy-Bold;
  font-size: 11px;
  line-height: 16px;
  color: #bcc5cc;
  margin-top: 8px;
}
.comments .v-text-field >>> .v-input__slot {
  border-radius: 6px !important;
  padding: 8px 8px 8px 24px !important;
  min-height: 48px !important;
  min-width: 100% !important;
  max-width: 100% !important;
  width: 100% !important;
  background-color: #f7f9fa !important;
}
.comments >>> .v-input__slot input {
  font-family: Gilroy-SemiBold;
  font-size: 11px;
  line-height: 16px;
  color: #a3a4a4 !important;
}
.comments .v-input--is-label-active >>> .v-input__slot {
  background-color: #f7f9fa !important;
}
.comments .v-btn--block {
  height: 32px !important;
  width: 90px;
}
.remove-comment {
  position: absolute;
  top: 0;
  right: 6px;
}
.mdi-close::before {
  top: -1px;
  position: relative;
}
@media only screen and (max-width: 1112px) {
  .comments {
    height: initial;
  }
}

@media only screen and (max-height: 1024px) {
  .comments {
    height: initial;
  }
}
</style>

<script>
import Vue from "vue";

import ApiService from "@/services/api.service";

export default Vue.extend({
  name: "Comments",
  props: {
    prognosticId: String
  },
  data: () => ({
    page: 1,
    message: "",
    comments: [],
    totalElements: 0,
    totalPages: 1,
    removeDialog: false
  }),
  created() {
    this.getComments(this.prognosticId, 0, 4);
  },
  methods: {
    getComments(prognosticId, page, size) {
      this.loading = true;
      ApiService.getGraphQLComments(prognosticId, page, size).then(
        response => {
          const data = response.data.data.getComments;
          this.comments = data.comments;
          this.totalPages = data.totalPages;
          this.loading = false;
        },
        error => {
          console.log(
            (error.response && error.response.data) ||
              error.message ||
              error.toString()
          );
        }
      );
    },
    addComment() {
      ApiService.addComment(this.prognosticId, this.message).then(
        response => {
          this.getComments(this.prognosticId, this.page - 1, 4);
          this.message = "";
        },
        error => {
          console.log(
            (error.response && error.response.data) ||
              error.message ||
              error.toString()
          );
        }
      );
    },
    removeComment(commentId) {
      ApiService.removeComment(this.prognosticId, commentId).then(
        response => {
          this.getComments(this.prognosticId, this.page - 1, 4);
        },
        error => {
          console.log(
            (error.response && error.response.data) ||
              error.message ||
              error.toString()
          );
        }
      );
    },
    gotToPage(page) {
      this.getComments(this.prognosticId, page - 1, 4);
    },
    avatar(photo) {
      if (photo) {
        return photo;
      } else {
        return require("../assets/images/avatar.png");
      }
    },
    isModerator() {
      return this.$store.state.admin || this.$store.state.moderator;
    }
  },
  computed: {
    commentsList() {
      return this.comments;
    }
  }
});
</script>
